const PIECE_COUNT = {
  8: 12,
  10: 20,
}

export default PIECE_COUNT
